import { render, staticRenderFns } from "./NsDataTable.vue?vue&type=template&id=1e032963&scoped=true&"
import script from "./NsDataTable.vue?vue&type=script&lang=js&"
export * from "./NsDataTable.vue?vue&type=script&lang=js&"
import style0 from "./NsDataTable.vue?vue&type=style&index=0&id=1e032963&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e032963",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NsSelect: require('/usr/app/src/components/ns/NsSelect.vue').default})
